(() => {
  function init(root) {
    root.querySelectorAll('.hg-page').forEach(page => {
      if(page.dataset.hgReady) return;
      page.dataset.hgReady='true';
      const photos=Array.from(page.querySelectorAll('.hg-thumb'));
      const active=page.querySelector('#hg-active-image');
      let index=0;
      function show(i) {
        index=(i+photos.length)%photos.length;
        active.src=photos[index].dataset.photo;
        photos.forEach((photo,n)=>{photo.classList.toggle('is-active',n===index);photo.setAttribute('aria-pressed',String(n===index));});
        photos[index].scrollIntoView({block:'nearest',inline:'nearest'});
      }
      photos.forEach((photo,i)=>photo.addEventListener('click',()=>show(i)));
      page.querySelector('.hg-prev').addEventListener('click',()=>show(index-1));
      page.querySelector('.hg-next').addEventListener('click',()=>show(index+1));
      const dialog=page.querySelector('.hg-lightbox');
      page.querySelector('.hg-zoom').addEventListener('click',()=>{dialog.querySelector('img').src=active.src;dialog.showModal();});
      dialog.querySelector('button').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      const group=page.querySelector('.hg-bundles');
      const variant=page.querySelector('#hg-variant');
      if(variant) variant.addEventListener('change',()=>{
        const option=variant.selectedOptions[0];
        const price=Number(option.dataset.price),compare=Number(option.dataset.compare);
        const format=new Intl.NumberFormat(group.dataset.locale,{style:'currency',currency:group.dataset.currency});
        group.querySelectorAll('[data-total]').forEach(el=>el.textContent=format.format(price*Number(el.dataset.total)/100));
        group.querySelectorAll('[data-compare]').forEach(el=>{el.hidden=compare<=price;el.textContent=format.format(compare*Number(el.dataset.compare)/100);});
        const button=page.querySelector('.hg-form .hg-add');
        button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.cartLabel;
      });
      page.querySelectorAll('.csx').forEach(cs=>{
        const panels=Array.from(cs.querySelectorAll('[data-csx-panel]'));
        const controls=Array.from(cs.querySelectorAll('[data-csx-tab]'));
        const desktop=()=>matchMedia('(min-width:750px)').matches;
        controls.forEach(button=>button.addEventListener('click',()=>{
          const id=button.dataset.csxTab;
          const target=panels.find(panel=>panel.dataset.csxPanel===id);
          const open=desktop()||!target.classList.contains('is-open');
          panels.forEach(panel=>{if(desktop()||panel===target)panel.classList.toggle('is-open',panel===target&&open);});
          controls.forEach(control=>{const expanded=panels.some(panel=>panel.dataset.csxPanel===control.dataset.csxTab&&panel.classList.contains('is-open'));control.setAttribute('aria-expanded',String(expanded));control.classList.toggle('is-active',expanded);});
        }));
        matchMedia('(min-width:750px)').addEventListener('change',()=>{if(desktop()){const first=panels.find(panel=>panel.classList.contains('is-open'))||panels[0];panels.forEach(panel=>panel.classList.toggle('is-open',panel===first));controls.forEach(control=>{const expanded=control.dataset.csxTab===first.dataset.csxPanel;control.setAttribute('aria-expanded',String(expanded));control.classList.toggle('is-active',expanded);});}});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
